<template>
  <div v-if="visible">
    <div :class="[{'opModal-overlay': modal}]" />
    <div :class="{ opModal: true, opModalActive: visible }" :style="extendStyle">
      <div class="opModal_header">
        <i v-if="isShowWarn" class="el-icon-warning" />
        <div v-if="$slots.title || title" class="opModal_head" />
        <div class="opModal_title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <div
          class="opModal_close"
          @click="handlerClose"
        >
          <i class="el-dialog__close el-icon el-icon-close" />
        </div>
      </div>
      <div class="opModal_body">
        <slot />
      </div>
      <div class="opModal_acknowledged">
        <slot name="isAcknowledged" />
      </div>
      <div
        v-if="isShowBtn"
        class="opModal_btns"
      >
        <OppleButton
          v-if="isShowCancelBtn"
          type="default"
          @click="handlerClose"
        >
          {{ cancelText || $t('limite.cancel') }}
        </OppleButton>
        <OppleButton
          :loading="loading"
          :disabled="disabled"
          @click="handlerOk"
        >
          {{ okText || $t('limite.ok') }}
        </OppleButton>
        <!-- <div
        class="opModal_btns_btn"
        @click="handlerClose"
      >
        
      </div>
      <div
        class="opModal_btns_btn opModal_btns_btn-ok"
        @click="handlerOk"
      >
        {{ okText || $t('limite.ok') }}
      </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import OppleButton from '@/components/Base/OppleButton/index.vue';

export default {
  components: {
    OppleButton
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible:  {
      type: Boolean,
      default: false
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    isBlueBackground: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false, // 是否加载中 [变淡 不可点击]
    },
    isShowCancelBtn: {
      type: Boolean,
      default: true
    },
    modal:{
      type: Boolean,
      default: true
    },
    isShowWarn: {
      type: Boolean,
      default: true
    },
    extendStyle: {
      type: Object,
      default: () => ({})
    },
    disabled:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  watch: {
    visible(isVisable) {
    }
  },
  methods: {
    handlerOk() {
      const slot = this.getSlot();
      const data = slot.getData instanceof Function ? slot.getData() : null;

      this.$emit('onOk', data);

      slot.clearData instanceof Function && slot.clearData();
    },
    handlerClose() {
      const slot = this.getSlot();

      slot.clearData instanceof Function && slot.clearData();

      this.$emit('onClose');
    },

    getSlot() {
      if (
        this.$slots.default &&
        this.$slots.default[0] &&
        this.$slots.default[0].componentInstance
      ) {
        return this.$slots.default[0].componentInstance;
      }

      return {};
    },

  }
}
</script>

<style lang="scss">
.opModal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9989;
}

.opModal {
  scrollbar-width:none;
  display: none;
  position: fixed;
  width: 400px;
  max-height: 700px;
  overflow: scroll;
  padding: 10px 13px 10px;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  background: #fff;
  // border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
  z-index: 9999;

  &.opModalActive {
    display: block;
  }

  &_acknowledged {
    display: flex;
    justify-content: flex-end;
  }
  
  &_header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  &_head {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 30px;
    font-size: 18px;
    justify-content: space-between;
    align-items: center;
    color: #333;
  }
  
   &_title {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.88);
    font-weight:600;
    font-size: 16px;
    line-height: 1.5;
  }

  .el-icon-warning {
    margin-right: 5px;
    font-size: 20px; 
    color: #ebaf13;
  }

  &_close {
   margin-left: auto;
  }

  &_body {
    scrollbar-width:none;
    display: flex;
    align-items: flex-start;
    min-height: 40px;
    overflow: scroll;
    font-size: 14px;
    //line-height: 24px;
    color: rgba(0, 0, 0, 0.88);
  }

  &_btns {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
    padding-bottom: 6px;

    &>div {
      margin-left: 6px;
    }
  }
}
.blueBackground{
  background: #E7ECF6;
}
</style>
